import React from 'react';
import { gatewayApi, locationApi } from '../../../services/apis';
import {
  ProfileTab,
  Toast,
  Tooltip,
  Spinner,
  MobileInfinityData,
  SideBarPanel,
} from '../../../component';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Conditional, returnGatewayTabList } from '../../../utils/consts';
import {
  BaggageIcon,
  PlusCircleIcon,
  GatewayIcon,
} from '../../../content/svg-component';
import { FormattedMessage } from 'react-intl';
import { fileHandlerUrl } from '../../../utils/consts/server';
import { debouncing, generateFilterString } from '../../../utils/utility';
import FilterPanel from './filterPanel';
import AddGateWayForm from './addGatewayFrom';
import Pagination from 'react-js-pagination';
import './gateway.scss';

class Gateway extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gateWaysList: [],
      gateWayRoadList: [],
      mobileGateWayRoadList: [],
      selectedGateWay: {},
      selectedLocation: {
        origin: '',
        destination: '',
      },
      locationList: {
        origin: [],
        destination: [],
      },
      locationPhrases: {
        destination: '',
        origin: '',
      },
      airlineTypePhrase: '',
      selectedTab: 'gatewaylist',
      gatewaySearchKey: '',
      gatewaySelectorePhrase: '',
      showToast: false,
      showAddGateWayModal: false,
      showLoading: false,
      mobileLoading: false,
      resetMobileGateWayData: false,
      pageNumber: 1,
      itemPerPage: 10,
      totalCount: 0,
      alertMessage: 'error.receiveerror',
      toastState: 'danger',
    };
  }

  async componentDidMount() {
    this.getAllGateways();
    this.getGateWayRoute();
    this.getFlightLocation('origin');
    this.getFlightLocation('destination');
  }

  getAllGateways = async () => {
    try {
      const {
        status,
        payload: { data },
      } = await gatewayApi.getGateway({
        itemPerPage: 20,
        pageNumber: 0,
        data: {
          filter: generateFilterString(this.gatewayFilterElements()),
        },
      });
      if (status === 200) {
        this.setState({
          gateWaysList: data,
        });
      }
    } catch (error) {
      this.setState({
        showToast: true,
        alertMessage: 'error.receiveerror',
        toastState: 'danger',
      });
    }
  };

  getGateWayRoute = async () => {
    const { resetMobileGateWayData } = this.state;
    let { mobileGateWayRoadList } = this.state;
    const { pageNumber } = this.state;
    try {
      const {
        status,
        payload: { data, totalRecords },
      } = await gatewayApi.getByPaging({
        pageNumber,
        itemPerPage: 10,
        data: {
          filter: generateFilterString(this.gatewayRouteFilterElements()),
          sort: { key: 'airlineCode', value: 'asc' },
        },
      });
      if (resetMobileGateWayData) mobileGateWayRoadList = [];
      if (status === 200)
        this.setState({
          gateWayRoadList: data,
          totalCount: totalRecords,
          mobileGateWayRoadList: [...mobileGateWayRoadList, ...data],
          resetMobileGateWayData: true,
        });
    } catch (error) {
      this.setState({
        showToast: true,
        alertMessage: 'error.receiveerror',
        toastState: 'danger',
      });
    } finally {
      this.setState({
        showLoading: false,
        mobileLoading: false,
      });
    }
  };

  getFlightLocation = async (locationType = 'origin') => {
    const { locationPhrases } = this.state;
    try {
      const {
        status,
        payload: { data },
      } = await locationApi.getAll({
        pageNumber: 1,
        itemPerPage: 25,
        data: {
          filter: {
            phrase: locationPhrases[locationType],
            countryCode: locationPhrases[locationType],
            type: locationPhrases[locationType],
          },
        },
      });
      if (status === 200) {
        this.setState((prevState) => ({
          locationList: {
            ...prevState.locationList,
            [locationType]: data,
          },
        }));
      }
    } catch (error) {
      this.setState({
        showToast: true,
        alertMessage: 'error.receiveerror',
        toastState: 'danger',
      });
    }
  };

  debouncingGetGateWay = debouncing(this.getAllGateways, 700);
  debouncingGetGateWayRoad = debouncing(this.getGateWayRoute, 700);
  debouncingGetLocation = debouncing(this.getFlightLocation, 700);

  handleTabClick = (tab) => {
    if (tab !== 'expired') {
      this.setState({
        selectedTab: tab,
        resetMobileGateWayData: true,
      });
    }
  };

  handleSearch = (e) => {
    this.setState(
      {
        gatewaySearchKey: e.target.value,
        pageNumber: 1,
        resetMobileGateWayData: true,
      },
      () => this.debouncingGetGateWayRoad(),
    );
  };

  handleLocationSearch = (event, type) => {
    this.setState(
      (...prevState) => ({
        locationPhrases: {
          ...prevState.locationPhrases,
          [type]: event.target.value,
        },
      }),
      () => this.debouncingGetLocation(type),
    );
  };

  handleSelectedLocation = (item, type) => {
    this.setState((prevState) => ({
      selectedLocation: {
        ...prevState.selectedLocation,
        [type]: item,
      },
    }));
  };

  handleSelectGateWay = (item) => {
    this.setState(
      {
        pageNumber: 1,
        selectedGateWay: item,
      },
      () => this.getGateWayRoute(),
    );
  };

  handleSearchGateWay = (e) => {
    this.setState(
      {
        gatewaySelectorePhrase: e.target.value,
      },
      () => this.debouncingGetGateWay(),
    );
  };

  handleSubmitRoute = () => {
    this.setState(
      {
        pageNumber: 1,
      },
      () => this.getGateWayRoute(),
    );
  };

  handleResetFilter = () => {
    this.setState(
      {
        selectedLocation: {
          origin: '',
          destination: '',
        },
        gatewaySearchKey: '',
        pageNumber: 1,
        resetMobileGateWayData: true,
        gatewaySelectorePhrase: '',
        selectedGateWay: '',
      },
      () => {
        this.scrollToTopCards(), this.getGateWayRoute(), this.getAllGateways();
      },
    );
  };

  scrollToTopCards = () => {
    let mobileGrid = document.querySelector('.infinity-scroll');
    mobileGrid?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  gatewayFilterElements = () => {
    const { gatewaySelectorePhrase } = this.state;
    return [{ key: 'phrase', value: gatewaySelectorePhrase }];
  };

  gatewayRouteFilterElements = () => {
    const { selectedGateWay, selectedLocation, gatewaySearchKey } = this.state;
    return [
      {
        key: 'internalCode',
        value: selectedGateWay?.internalCode,
      },
      {
        key: 'airlineCode',
        value: gatewaySearchKey,
      },
      {
        key: 'from',
        value: selectedLocation?.origin?.code,
      },
      {
        key: 'to',
        value: selectedLocation?.destination?.code,
      },
    ];
  };

  GateWayListColumn = ({ name, value, className }) => {
    const {
      language: { direction },
      intl,
    } = this.props;
    let title = `${intl.formatMessage({
      id: name,
    })}`;
    return (
      <div
        className={`flex-column col-xl-2 col-6 d-sm-flex text-capitalize font-weight-bold px-1 justify-content-center align-items-center ${className} `}
      >
        <Tooltip
          position={'top'}
          content={title || ''}
          direction={direction}
          backgroundColor="warning"
          textColor="dark"
          customClassName={'w-100'}
        >
          <div className="w-100 d-flex font-xxl-smaller font-xl-xsmall font-sm-smaller font-xsmall text-third text-start pt-xl-0 pt-2 text-nowrap text-truncate">
            {direction === 'ltr' ? (
              <>
                <span className="text-nowrap text-truncate">
                  {title || '---'}
                </span>
              </>
            ) : (
              <>
                <span> {name ? title : '--'}</span>
              </>
            )}
          </div>
        </Tooltip>
        <div
          className={`w-100 flex-column text-start  font-weight-bold text-dark  font-small  d-flex`}
        >
          <Tooltip
            position={'top'}
            content={value || ''}
            direction={direction}
            backgroundColor="warning"
            textColor="dark"
          >
            <span className="d-flex justify-content-start text-break flex-wrap font-xsmall font-xs-smaller font-sm-msmall font-md-small font-xl-smaller text-nowrap text-truncate">
              <span className="text-nowrap text-truncate">
                {value || '---'}
              </span>
            </span>
          </Tooltip>
        </div>
      </div>
    );
  };

  GateWayListRow = ({ gateWay = {}, index = 0, onEdit, onDelete }) => {
    const { pageNumber, itemPerPage } = this.state;
    const {
      language: { direction, name },
    } = this.props;
    const { GateWayListColumn } = this;
    return (
      <div className="w-100 mt-2 px-3">
        <div
          className="bookingFlightCard default-border-radius-small  cursor-pointer d-flex flex-column align-items-center justify-content-center bg-white shadow"
          key={gateWay._id}
        >
          <div className="card-body py-3 px-0 w-100 d-flex flex-sm-row flex-column align-items-md-center align-items-start">
            <div className="d-flex flex-row col-sm col-12 px-0">
              <div className="d-sm-flex d-none flex-column justify-content-center px-3 text-dark">
                {(pageNumber - 1) * itemPerPage + (index + 1)}
              </div>
              <div className="d-sm-flex d-none px-md-2 px-0 flex-column align-items-start justify-content-center h-100 width-profile-pic">
                <img
                  style={{ width: '40px', height: '40px' }}
                  className="d-flex justify-content-center rounded-circle bg-white border border-1 p-1"
                  src={`${fileHandlerUrl}/icons/airlines/${gateWay?.airlineCode}.png`}
                  alt=""
                />
              </div>
              <div className="d-sm-none d-flex col-sm-3 col-9 px-2 align-items-center">
                <div className="d-flex flex-column justify-content-center px-2 text-dark">
                  {index + 1}
                </div>
                <div className="d-flex px-md-3 px-0 flex-column align-items-start justify-content-center h-100 width-profile-pic">
                  <img
                    style={{ width: '40px', height: '40px' }}
                    className="d-flex justify-content-center rounded-circle bg-white border border-1 p-1"
                    src={`${fileHandlerUrl}/icons/airlines/${gateWay?.airlineCode}.png`}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div
              className={`flex-sm-fill col-sm- col-12 d-flex flex-row justify-content-between flex-wrap px-md-0 px-sm-3 ${
                direction === 'rtl' ? 'pr-5' : 'pl-5'
              } `}
            >
              <GateWayListColumn
                name="profile.airlinecode"
                value={gateWay?.airlineCode}
                className=""
              />
              <GateWayListColumn
                name="profile.internalcode"
                value={gateWay?.internalCode}
                className={''}
              />
              <GateWayListColumn name="booking.from" value={gateWay?.from} />
              <GateWayListColumn name="booking.to" value={gateWay?.to} />
              <GateWayListColumn
                name="profile.weekdays"
                value={gateWay?.weekDays}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
        showToast,
        alertMessage,
        toastState,
        selectedTab,
        selectedGateWay,
        gateWayRoadList,
        gateWaysList,
        totalCount,
        itemPerPage,
        pageNumber,
        showLoading,
        locationList,
        gatewaySearchKey,
        selectedLocation,
        mobileLoading,
        mobileGateWayRoadList,
        gatewaySelectorePhrase,
      } = this.state,
      {
        language,
        language: { direction, name },
        intl,
      } = this.props;
    const filtersData = {
      originList: locationList.origin,
      destinationList: locationList.destination,
      gateWaysList,
      selectedGateWay,
      gatewaySearchKey,
      selectedOrigin: selectedLocation.origin,
      selectedDestination: selectedLocation.destination,
      gatewaySelectorePhrase,
    };
    const { GateWayListRow } = this;
    const TAB_LIST = returnGatewayTabList(),
      SVG_COMPONENTS = {
        gatewaylist: GatewayIcon,
        addgateway: PlusCircleIcon,
        expired: BaggageIcon,
      };

    return (
      <>
        <Toast
          isOpen={showToast}
          onClose={() => {
            this.setState({ showToast: false });
          }}
          state={toastState}
          position="bottom"
          message={intl.formatMessage({
            id: alertMessage,
          })}
          direction={direction}
        />
        <div className="w-100 h-100 d-flex">
          <div className="col-md-9 col-12 py-4 px-2 d-flex flex-column">
            <div className="w-100  d-flex justify-content-between pb-4">
              {TAB_LIST.map((tab, tabIndex) => {
                return (
                  <div className="col-4 px-0" key={tabIndex}>
                    <ProfileTab
                      key={`tab-profile-${tabIndex}`}
                      {...tab}
                      svgIcon={React.createElement(
                        SVG_COMPONENTS[tab.tabName],
                        {
                          color: 'white',
                          variant: 'svg-md-normal svg-sm-large svg-msmall',
                        },
                      )}
                      handleTabClick={this.handleTabClick}
                      selectedTab={selectedTab}
                    />
                  </div>
                );
              })}
            </div>
            {selectedTab === 'gatewaylist' ? (
              <>
                <div className="w-100 d-flex">
                  <FilterPanel
                    gateWaysList={gateWaysList}
                    intl={intl}
                    language={language}
                    originList={locationList.origin}
                    destinationList={locationList.destination}
                    filtersData={filtersData}
                    handleSearch={this.handleSearch}
                    fetchLocations={this.handleLocationSearch}
                    handleSelectedLocation={this.handleSelectedLocation}
                    handleSubmitRoute={this.handleSubmitRoute}
                    handleResetFilter={this.handleResetFilter}
                    handleSearchGateWay={this.handleSearchGateWay}
                    handleSelectGateWay={this.handleSelectGateWay}
                    handleClickedModal={() =>
                      this.setState({
                        showAddGateWayModal: true,
                      })
                    }
                  />
                </div>
                <Conditional checkRender={gateWayRoadList?.length}>
                  <>
                    <div className="w-100 d-md-flex d-none flex-column flex-fill justify-content-between">
                      <div className="w-100 d-flex flex-column">
                        {gateWayRoadList.map((item, index) => {
                          return (
                            <React.Fragment key={`gatewayCard-${item._id}`}>
                              <GateWayListRow gateWay={item} index={index} />
                            </React.Fragment>
                          );
                        })}
                      </div>
                      {totalCount > itemPerPage && (
                        <div className="w-100 d-flex justify-content-center">
                          <Pagination
                            linkClass="page-link"
                            itemClass="page-item"
                            innerClass="pagination m-0 pt-4 directionInitial"
                            activeClass="text-primary active"
                            activePage={pageNumber}
                            itemsCountPerPage={itemPerPage}
                            totalItemsCount={totalCount}
                            onChange={(event) => {
                              if (this.state.pageNumber !== event) {
                                this.setState(
                                  {
                                    showLoading: true,
                                    gateWayRoadList: [],
                                    pageNumber: event,
                                    resetMobileGateWayData: false,
                                  },
                                  () => {
                                    this.getGateWayRoute();
                                  },
                                );
                              }
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <MobileInfinityData
                      isShowLoadingBar={mobileLoading}
                      totalRecords={totalCount}
                      itemPerPage={itemPerPage}
                      data={mobileGateWayRoadList}
                      handleCallData={() => (
                        this.setState({ mobileLoading: true }),
                        setTimeout(() => {
                          this.setState(
                            {
                              pageNumber: pageNumber + 1,
                              resetMobileGateWayData: false,
                            },
                            () => {
                              this.debouncingGetGateWayRoad();
                            },
                          );
                        }, 1000)
                      )}
                      customClassName="pb-4"
                    >
                      {mobileGateWayRoadList.map((item, index) => {
                        return (
                          <React.Fragment key={`gatewayCard-${index}`}>
                            <GateWayListRow gateWay={item} index={index} />
                          </React.Fragment>
                        );
                      })}
                    </MobileInfinityData>
                  </>
                </Conditional>
                <Conditional
                  checkRender={!showLoading && gateWayRoadList?.length == 0}
                >
                  <h3 className="text-center flex-fill px-3 pb-3 pt-3">
                    <FormattedMessage id="profile.notfound" />
                  </h3>
                </Conditional>
                <Conditional
                  checkRender={showLoading && gateWayRoadList?.length == 0}
                >
                  <Spinner />
                </Conditional>
              </>
            ) : selectedTab === 'addgateway' ? (
              <AddGateWayForm
                intl={intl}
                language={language}
                setToastData={(e) => {
                  this.setState({
                    showToast: true,
                    alertMessage: e.alertMessage,
                    toastState: e.toastState,
                  });
                }}
              />
            ) : (
              ''
            )}
          </div>
          <SideBarPanel direction={direction}></SideBarPanel>
        </div>
      </>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    language: state.language,
    user: state?.user?.userInfo,
  };
}

export default injectIntl(connect(mapStateToProps)(Gateway));
